import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@quintoandar-tokko/jopijs';
import { setTabActive } from '@/store/slices/components/dashboard/DashboardSlice';
import styles from './tabs.module.scss';
import Trans from '@/components/shared/Trans';
import translations from '../Dashboard.trans.json';
import { DASHBOARD_TABS } from '../constants';
import { useTrackDashboardTabs } from '../customHooks/useTrackDashboard';

function DashboardTabs() {
  const dispatch = useDispatch();
  const { tabActive } = useSelector((state) => state.DashboardSlice);
  const track = useTrackDashboardTabs();

  const tabs = [
    { label: Trans(translations, 'ToDo'), key: DASHBOARD_TABS.TODO },
    {
      label: Trans(translations, 'Overview'),
      key: DASHBOARD_TABS.OVERVIEW,
    },
    {
      label: Trans(translations, 'Performance'),
      key: DASHBOARD_TABS.PERFORMANCE,
    },
  ];

  const handleClickTab = (tab) => {
    const trackMap = {
      [DASHBOARD_TABS.TODO]: track.pending,
      [DASHBOARD_TABS.OVERVIEW]: track.overview,
      [DASHBOARD_TABS.PERFORMANCE]: track.performance,
    };

    const trackFn = trackMap[tab.key];

    trackFn();
    dispatch(setTabActive(tab.key));
  };

  return (
    <Box className={styles.tabsContainer}>
      {tabs.map((tab) => (
        <Box
          key={tab.key}
          data-active={tab.key === tabActive}
          className={styles.tab}
          onClick={() => handleClickTab(tab)}
        >
          {tab.label}
        </Box>
      ))}
    </Box>
  );
}

export default DashboardTabs;
